var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_1863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.4375C11.0747 15.4375 12.5849 14.8119 13.6984 13.6984C14.8119 12.5849 15.4375 11.0747 15.4375 9.5C15.4375 7.92528 14.8119 6.41505 13.6984 5.30155C12.5849 4.18806 11.0747 3.5625 9.5 3.5625C7.92528 3.5625 6.41505 4.18806 5.30155 5.30155C4.18806 6.41505 3.5625 7.92528 3.5625 9.5C3.5625 11.0747 4.18806 12.5849 5.30155 13.6984C6.41505 14.8119 7.92528 15.4375 9.5 15.4375V15.4375Z",
    stroke: "#1A4855",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49967 3.16668V1.58334M3.16634 9.50001H1.58301M9.49967 15.8333V17.4167M15.833 9.50001H17.4163M9.49967 11.875C10.1296 11.875 10.7337 11.6248 11.1791 11.1794C11.6245 10.734 11.8747 10.1299 11.8747 9.50001C11.8747 8.87012 11.6245 8.26603 11.1791 7.82063C10.7337 7.37523 10.1296 7.12501 9.49967 7.12501C8.86978 7.12501 8.26569 7.37523 7.8203 7.82063C7.3749 8.26603 7.12467 8.87012 7.12467 9.50001C7.12467 10.1299 7.3749 10.734 7.8203 11.1794C8.26569 11.6248 8.86978 11.875 9.49967 11.875V11.875Z",
    stroke: "#1A4855",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_1863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.cfdcacb467a8c4ee2fbafb53f783fb18.svg";
export { ForwardRef as ReactComponent };